module.exports = __webpack_public_path__ + "d647751b89f432486ac5804562d1f4c8.svg";